<template>
  <div class="pwc-app-container" :style="cStyle">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    shadow: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: -1
    }
  },
  computed: {
    cStyle() {
      let maxWitdh = '960px'
      if (this.max !== -1) {
        maxWitdh = `${this.max}px`
      }
      if (this.shadow) {
        return {
          'max-width': maxWitdh,
          'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.08)'
        }
      } else {
        return {
          'max-width': maxWitdh,
          'box-shadow': 'none'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pwc-app-container {
    // max-width: 960px;
    margin:auto;
    margin-top: 36px;
    margin-bottom: 20px;

    @media only screen and (max-width: 980px) {
        width: 100%;
        box-shadow:none;
    }
}
</style>
